var m = /* @__PURE__ */ ((e) => (e.small = "1em", e.medium = "2em", e.large = "3em", e))(m || {}), a = /* @__PURE__ */ ((e) => (e.INSIDE = "0px", e.OUTSIDE = "-5em", e))(a || {});
export {
  a as ArrowPosition,
  m as ArrowSize
};
//# sourceMappingURL=CarouselArrows.types.js.map
